import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { CanLoad, Router } from '@angular/router';
import { AccountService } from '../services/account/account.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
@Injectable({
    providedIn: 'root',
})
export class AccessGuard implements CanLoad {
    constructor(
        private dialog: MatDialog,
        private router: Router,
        private authService: AccountService,
        private translate: TranslateService
    ) {}
    dialogRef: MatDialogRef<DialogComponent> | undefined;
    canLoad(): boolean {
        let errorMsg = '';
        if (!this.authService.getIsAuth()) {
            this.router.navigate(['auth', 'signin']);
            return false;
        }
        let user = JSON.parse(
            localStorage.getItem('userInfo')?.toString() || '{}'
        );
        if (user&&user.endDate && user.startDate) {
            let endDate = moment(user.endDate, "DD/MM/YYYY");
            let startDate = moment(user.startDate, "DD/MM/YYYY");
            let today =  moment();
            if ((moment(startDate).isSameOrBefore(today, 'day')) && moment(today).isSameOrBefore(endDate, 'day') ) {
                return true;
            }else
            if (moment(today).isBefore(startDate, 'day')) {
                errorMsg = this.translate.instant('GENERAL.IT_WILL_BE_ACTIVE_ON')+user.startDate
                
            }else
            if (moment(endDate).isBefore(today, 'day')) {
                errorMsg = this.translate.instant('GENERAL.THE_END_OF_THE_SUBSCRIPTION_WAS')+user.endDate
            }
        }

        this.dialogRef = this.dialog.open(DialogComponent);
        this.dialogRef.componentInstance.heading = 'Information';
        this.dialogRef.componentInstance.messages = [
            'GENERAL.SUBSCRIPTION_EXPIRED',errorMsg
        ];
        return false;
    }
    changeDateFormat(date: string) {
        if (date.includes('/')) {
            let splitDate: string[] = date.split('/');
            if (splitDate.length == 3)
                return splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
        } else if (date.includes('-')) {
            let splitDate: string[] = date.split('-');
            if (splitDate.length == 3)
                return splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
        }
        return '00-00-0000';
    }
}
